module.exports = __webpack_public_path__ + "img/icon-24-ic-flash-off.05f0e3cc.svg";